import { render, staticRenderFns } from "./cart_bar.vue?vue&type=template&id=1c4fe7c0&scoped=true"
import script from "./cart_bar.vue?vue&type=script&lang=js"
export * from "./cart_bar.vue?vue&type=script&lang=js"
import style0 from "./cart_bar.vue?vue&type=style&index=0&id=1c4fe7c0&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4fe7c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\chenwllCode\\cunxian\\web-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c4fe7c0')) {
      api.createRecord('1c4fe7c0', component.options)
    } else {
      api.reload('1c4fe7c0', component.options)
    }
    module.hot.accept("./cart_bar.vue?vue&type=template&id=1c4fe7c0&scoped=true", function () {
      api.rerender('1c4fe7c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/design/components/mobilePage/cart_bar.vue"
export default component.exports